import { WSQueryConfig } from "@ws-react-query";
import { WSServiceError } from "../../../utils/serviceHelper";
import { useWSQuery } from "../../helpers";
import { IEngagementResponse } from "@wingspanhq/payments/dist/interfaces";
import { getEngagement } from "../../../services/engagements";
import { QUERY_ENGAGEMENT } from "../keys";
import { useXWingspanPayerId } from "../../../modules/Payees/routes/RoutePayeeDetails/useXWingspanPayerId";

export const useQueryEngagement = (
  id: string,
  config?: WSQueryConfig<IEngagementResponse, WSServiceError>
) => {
  const xWingspanPayerId = useXWingspanPayerId();

  return useWSQuery<IEngagementResponse, WSServiceError>(
    [QUERY_ENGAGEMENT, id, xWingspanPayerId],
    async () => {
      return await getEngagement(id, xWingspanPayerId);
    },
    {
      ...config
    }
  );
};
